// @flow
import React from 'react';
import classNames from 'classnames';
import Loader from 'sulu-admin-bundle/components/Loader';
import Button from 'sulu-admin-bundle/components/MultiItemSelection/Button';
import headerStyles from 'sulu-admin-bundle/components/MultiItemSelection/header.scss';

import type {Button as ButtonConfig} from 'sulu-admin-bundle/components/MultiItemSelection/types';
import type {Node} from 'react';

const LOADER_SIZE = 24;

type Props<T, U> = {
    disabled: boolean,
    emptyList: boolean,
    label?:  Node,
    leftButton?: ButtonConfig<T>,
    loading: boolean,
    rightButton?: ButtonConfig<U>,
};

export default class Header<T: string | number, U: string | number> extends React.PureComponent<Props<T, U>> {
    static defaultProps = {
        disabled: false,
        emptyList: true,
    };

    render() {
        const {
            disabled,
            label,
            loading,
            emptyList,
            leftButton,
            rightButton,
            header
        } = this.props;

        const headerClass = classNames(
            headerStyles.header,
            {
                [headerStyles.disabled]: disabled,
                [headerStyles.emptyList]: emptyList,
            }
        );

        const columns = []; // receive react node
        
        const headerColumns =  header ? header(): (<></>);


        return (
            <div className={headerClass}>
                {leftButton &&
                    <Button {...leftButton} location="left" />
                }
                <div 
                    className={headerStyles.label}
                >
                    {loading &&
                        <div className={headerStyles.loader}>
                            <Loader size={LOADER_SIZE} />
                        </div>
                    }
                    {!loading &&
                        headerColumns
                    }
                    {/*<div style={{ display: "flex;",flexDirection: "row;", justifyContent: 'space-between;'}}>{[...Array(5).keys()].map(el=><div id={el}>el</div>)}</div>*/}

                </div>
                {rightButton &&
                    <Button {...rightButton} location="right" />
                }
            </div>
        );
    }
}
